export const scriptFunction = (size: string | null, template?: string) => {
  const defaultValue: Record<string, number[]> = {
    ComboBanner: [16],
    PromoBanner: [16],
    ProductBanner: [9],
    MessageBanner: [10, 11]
  }
  const scriptValue: Record<string, number[]> = {
    small: [9],
    medium: [11],
    large: [16]
  }
  const scriptFontSize: number[] = size === null ? defaultValue[template || ''] : scriptValue[size.toLowerCase()]     
  return scriptFontSize
}
